import {
  FileExcelOutlined,
  ReloadOutlined,
  SearchOutlined
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Layout,
  Radio,
  Row,
  Select,
  Table
} from "antd";
import { get, toNumber } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiCaller } from "src/util/apiCaller";
import { exportToExcel, listTrangThai } from "src/util/Commom";
import { MessageStatusError } from "src/util/MessageStatus";

interface NhomSoLuong {
  idNhomTuLieu: number;
  tenNhomTuLieu: string;
  soLuong: number;
}

interface NguoiDang {
  idNguoiDang: number;
  tenNguoiDang: string;
  nhomSoLuong: NhomSoLuong[];
}

interface TableData {
  key: number;
  idNguoiDang: number;
  tenNguoiDang: any;
  [key: string]: any; // cho phép thêm động key khác
}

const FormItem = Form.Item;

const ThongKeTheoNguoiNhap = ({ status }: any) => {
  const [form] = Form.useForm();
  const { isActive } = status;
  const { resetFields } = form;
  const navigate = useNavigate();
  const [isLoadTable, setIsLoadTable] = useState(false);
  const [dataTable, setDataTable] = useState<NguoiDang[]>([]);
  const [listNguoiDung, setListNguoiDung] = useState([]);
  const [loadingNguoiDung, setLoadingNguoiDung] = useState(false);
  const [listDanToc, setListDanToc] = useState([]);
  const [loadingDanToc, setLoadingDanToc] = useState(false);
  const [listHanLuuTru, setListHanLuuTru] = useState([]);
  const [loadingHanLT, setLoadingHanLT] = useState(false);
  const [isHinhanh, setIsHinhAnh] = useState<boolean>(true);
  const [isTuLieu, setIsTuLieu] = useState<boolean>(true);
  const [isVideo, setVideo] = useState<boolean>(true);
  const [isCoBaiDang, setIsCoBaiDang] = useState<boolean>(true);

  const listTuLieu = [
    { label: "---Tất cả---", value: "" },
    { label: "Hình ảnh", value: "hinhanh" },
    { label: "Tư liệu", value: "tulieu" },
    { label: "Video", value: "video" }
  ];
  const listCoBaiDang = [
    { label: "Có bài đăng", value: true },
    { label: "Không có bài đăng", value: false }
  ];
  const [searchParams] = useState({
    idnguoidang: "",
    trangthai: "",
    madantoc: "",
    idhan: "",
    tulieu: ""
  });

  useEffect(() => {
    if (isActive) {
      getListData(
        searchParams.idnguoidang,
        searchParams.madantoc,
        searchParams.trangthai,
        searchParams.idhan
      );
      getNguoiDung();
      getDanToc();
      getHanLuuTru();
    } else {
      navigate("/error/401");
    }
  }, []);

  /**
   * getListData: gọi danh sách quyền
   * @param {number} activePage
   * @memberof Quyen
   */
  const getListData = async (
    idnguoidang: any,
    madantoc: any,
    trangthai: any,
    idhan: any
  ) => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/thongke/nguoidang?idnguoidang=${idnguoidang || ""}&madantoc=${
        madantoc || ""
      }&trangthai=${trangthai || ""}&idhan=${
        idhan || ""
      }&istulieu=${isTuLieu}&isvideo=${isVideo}&ishinhanh=${isHinhanh}&iscobaidang=${isCoBaiDang}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listQuyen"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response, "data", []);
        setDataTable(data as NguoiDang[]);
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  const getNguoiDung = async () => {
    setLoadingNguoiDung(true);
    const configAPI = {
      url: `api/nguoidungs`,
      method: "GET",
      value: null,
      apiType: "LIST",
      params: {
        page: 0
      },
      getName: "listNguoiDung"
    };
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = [
          { hoVaTen: "---Tất cả---", id: "" },
          ...get(response.data, "content", [])
        ];
        setListNguoiDung(data as any);
        setLoadingNguoiDung(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingNguoiDung(false);
      }
    } catch (error) {
      setLoadingNguoiDung(false);
      error;
    }
  };

  const getDanToc = async () => {
    setLoadingDanToc(true);
    const configAPI = {
      url: `api/dmdc/dantocs`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listDanToc"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = [
          { tenGoi: "---Tất cả---", maDanToc: "" },
          ...get(response, "data", [])
        ];
        setListDanToc(data as any);
        setLoadingDanToc(false);
        false;
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingDanToc(false);
      }
    } finally {
      setLoadingDanToc(false);
    }
  };

  const getHanLuuTru = async () => {
    setLoadingHanLT(true);
    const configAPI = {
      url: `api/hanluutrus?keyword=`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listThoiHanLuuTru"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = [
          { tenHanLuuTru: "---Tất cả---", id: "" },
          ...get(response.data, "content", [])
        ];
        setListHanLuuTru(data as any);
        setLoadingHanLT(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setLoadingHanLT(false);
    }
  };

  const columns =
    dataTable.length > 0
      ? dataTable[0].nhomSoLuong.map((item) => ({
          title: item.tenNhomTuLieu,
          dataIndex: item.tenNhomTuLieu,
          key: item.idNhomTuLieu
        }))
      : [];

  const tableData: TableData[] = dataTable.map((item, index) => {
    const row: TableData = {
      key: index + 1,
      idNguoiDang: item.idNguoiDang,
      tenNguoiDang: item.tenNguoiDang
    };
    item.nhomSoLuong.forEach((nhom) => {
      row[nhom.tenNhomTuLieu] = nhom.soLuong;
    });
    return row;
  });

   /**
   * renderTitle: hiển thị màu title table
   * @param {String} text
   * @param {object} record
   * @param {String} title
   * @memberof DonThuDaNhapList
   */
   const renderTitle = (text: string, record: any) => {
    return (
      <span
        onClick={() =>  navigate(`/thong-ke/chi-tiet/theo-nguoi-nhap/${record.idNguoiDang}`)}
        style={{ cursor: "pointer", color: "#0065ff" }}
        title="Xem chi tiết"
      >
        {text}
      </span>
    )
   };

  const handleXuatExcel = async () => {
    exportToExcel(dataTable, "thong-ke-theo-nguoi-nhap");
  };

  const onFinish = (values: any) => {
    getListData(
      values.idnguoidang,
      values.madantoc,
      values.trangthai,
      values.idhan
    );
  };

  /**
   * handleReset: làm mới form tìm kiếm
   * @memberof LoaiTaiLieu
   */
  const handleReset = () => {
    setIsHinhAnh(true);
    setIsTuLieu(true);
    setVideo(true);
    setIsCoBaiDang(true);
    setTimeout(() => {
      resetFields();
    }, 0);
  };

  const onChangeTuLieu = (value: any) => {
    if (value === "") {
      setIsHinhAnh(true);
      setIsTuLieu(true);
      setVideo(true);
    }
    if (value === "hinhanh") {
      setIsHinhAnh(true);
      setIsTuLieu(false);
      setVideo(false);
    }
    if (value === "video") {
      setIsHinhAnh(false);
      setIsTuLieu(false);
      setVideo(true);
    }
    if (value === "tulieu") {
      setIsHinhAnh(false);
      setIsTuLieu(true);
      setVideo(false);
    }
  };
  const onChangeTuLieuBaiDang = (e: any) => {
    setIsCoBaiDang(e.target.value);
  };

  return (
    <Layout>
      <Flex justify="space-between" align="center">
        <h3 style={{ color: "black", fontSize: 20 }}>
          Thống kê theo người nhập
        </h3>
      </Flex>
      <Card style={{ marginBottom: 15 }}>
        <Form
          layout="vertical"
          form={form}
          name="tulieu-control"
          onFinish={onFinish}
        >
          <Col>
            <Row gutter={16} style={{ marginTop: -2 }}>
              <Col md={6} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Người nhập"
                  name="idnguoidang"
                  initialValue={searchParams.idnguoidang || ""}
                >
                  <Select
                    allowClear
                    loading={loadingNguoiDung}
                    placeholder="Chọn người nhập"
                    style={{ width: "100%" }}
                    options={listNguoiDung}
                    fieldNames={{ label: "hoVaTen", value: "id" }}
                  />
                </FormItem>
              </Col>
              <Col md={6} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Dân tộc"
                  name="madantoc"
                  initialValue={searchParams.madantoc || ""}
                >
                  <Select
                    allowClear
                    showSearch
                    loading={loadingDanToc}
                    placeholder="Chọn dân tộc"
                    style={{ width: "100%" }}
                    options={listDanToc}
                    optionFilterProp="tenGoi"
                    filterOption={(input, option: any) =>
                      (option?.tenGoi ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    fieldNames={{ label: "tenGoi", value: "maDanToc" }}
                  />
                </FormItem>
              </Col>
              <Col md={6} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Trạng thái"
                  name="trangthai"
                  initialValue={searchParams.trangthai || ""}
                >
                  <Select
                    allowClear
                    placeholder="Chọn trạng thái"
                    style={{ width: "100%" }}
                    options={[
                      { label: "---Tất cả---", value: "" },
                      ...listTrangThai
                    ]}
                    fieldNames={{ label: "label", value: "value" }}
                  />
                </FormItem>
              </Col>
              <Col md={6} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Hạn lưu trữ"
                  name="idhan"
                  initialValue={searchParams.idhan || ""}
                >
                  <Select
                    allowClear
                    loading={loadingHanLT}
                    placeholder="Chọn hạn lưu trữ"
                    style={{ width: "100%" }}
                    options={listHanLuuTru}
                    fieldNames={{ label: "tenHanLuuTru", value: "id" }}
                  />
                </FormItem>
              </Col>
              <Col md={6} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Tài liệu"
                  name="tulieu"
                  initialValue={searchParams.tulieu || ""}
                >
                  <Select
                    allowClear
                    placeholder="Chọn tài liệu"
                    onChange={onChangeTuLieu}
                    style={{ width: "100%" }}
                    options={listTuLieu}
                    fieldNames={{ label: "label", value: "value" }}
                  />
                </FormItem>
              </Col>
              <Col md={6} xs={24}>
                <FormItem
                  label="Bài đăng"
                  name="isCoBaiDang"
                  initialValue={isCoBaiDang}
                >
                  <Radio.Group
                    options={listCoBaiDang}
                    name="isCoBaiDang"
                    onChange={onChangeTuLieuBaiDang}
                  />
                </FormItem>
              </Col>
              <Col md={12} xs={24}>
                <FormItem label={<span>&nbsp;</span>}>
                  <Button
                    type="primary"
                    style={{ marginRight: "10px", backgroundColor: "#0d5ace" }}
                    htmlType="submit"
                  >
                    <div className="content-btn">
                      <span className="name">
                        <SearchOutlined /> Tìm kiếm
                      </span>
                    </div>
                  </Button>
                  <Button onClick={handleReset}>
                    <div className="content-btn">
                      <span className="name">
                        <ReloadOutlined /> Làm mới
                      </span>
                    </div>
                  </Button>
                  <Button
                    type="primary"
                    style={{ background: "green", marginLeft: 15 }}
                    onClick={handleXuatExcel}
                  >
                    <div className="content-btn">
                      <span className="name">
                        <FileExcelOutlined /> Xuất excel
                      </span>
                    </div>
                  </Button>
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Form>
      </Card>
      <Card>
        <Table
          rowKey={"key"}
          bordered
          size="middle"
          columns={[
            {
              title: "STT",
              dataIndex: "key",
              key: "key",
              width: "5%",
              align: "center"
            },
            {
              title: "Tên người đăng",
              dataIndex: "tenNguoiDang",
              key: "tenNguoiDang",
              render: (text, record) => renderTitle(text, record)
            },
            ...columns
          ]}
          dataSource={tableData}
          pagination={false}
          loading={isLoadTable}
          className="qti-table-wrapper gx-table-responsive"
          scroll={{ x: 1000 }}
        />
      </Card>
    </Layout>
  );
};

export default ThongKeTheoNguoiNhap;
